import get from 'lodash/get'
import { withRouter } from 'next/router'
import { connect } from 'react-redux'
import { compose } from 'redux'

import GenericPageContainer from './GenericPageContainer'


export default compose(
  withRouter,
  connect(state => ({
    seoTemplates: get(state, 'cmsInfo.data.seo_templates', {}),
    homeSlugs: get(state, 'cmsInfo.data.home_page_slugs', {}),
  })),
)(GenericPageContainer)
